import PropTypes from 'prop-types';
import {
  compose,
  isEmpty,
  isNil,
  pluck,
  reject
} from 'ramda';
import BeneficiaryRefund from './BeneficiaryRefund';
import { mapIndexed } from '@@serverHelpers/index.mjs';
import { Button, Icon } from '@fasstech/middle-design-system';
import React from 'react';
import useBeneficiariesRefund from '../hooks/useBeneficiariesRefund.js';

const BeneficiariesRefund = ({
  selectedTab,
  getMiddleText,
  getMiddleBoolean,
  grantees,
  fields,
  form,
  setTabs,
  append,
  remove,
  setManualTrigger
}) => {
  const { handleAddBeneficiary, displayAddButton, handleRemoveBeneficiary } =
    useBeneficiariesRefund({
      grantees,
      form,
      setTabs,
      append,
      remove,
      fields,
      setManualTrigger
    });

  const fieldsWithoutBankAccounts = reject((e) => isEmpty(e.bankAccounts), fields);

  const filterAvailableGrantees = compose(reject(isNil), pluck('id'))(fieldsWithoutBankAccounts);

  return (
    <>
      {mapIndexed((field, index) => {
        return (
          <BeneficiaryRefund
            key={field.key}
            index={index}
            selectedTab={selectedTab}
            handleRemoveBeneficiary={handleRemoveBeneficiary}
            getMiddleText={getMiddleText}
            getMiddleBoolean={getMiddleBoolean}
            availableGranteesId={filterAvailableGrantees}
            fields={fieldsWithoutBankAccounts}
            granteesWithoutBankAccount={grantees}
          />
        );
      })(fieldsWithoutBankAccounts)}
      {getMiddleBoolean('PAIEMENTETREMBOURSEMENT_REMBOURSEMENT_EST_NECESSAIRE') &&
        getMiddleBoolean('PAIEMENTETREMBOURSEMENT_REMBOURSEMENT_RIB_BENEFICIAIRE_EST_NECESSAIRE') &&
        displayAddButton && (
        <Button
          data-testid="ADD_BENEFICIARY_IBAN_BUTTON"
          variant="text"
          onClick={handleAddBeneficiary}
          className="flex! justify-start! p-0! font-bold w-full whitespace-nowrap">
          <div className={'flex items-center'}>
            <Icon name={'plus'} className={'mr-2'} />
            {getMiddleText('PAIEMENTETREMBOURSEMENT_REMBOURSEMENT_RIB_BENEFICIAIRE_AJOUT_LABEL')}
          </div>
        </Button>
      )}
    </>
  );
};
BeneficiariesRefund.propTypes = {
  currentSubStep: PropTypes.number,
  onSubStepChange: PropTypes.func,
  beneficiaries: PropTypes.array,
  displayThisComponent: PropTypes.func
};

export default BeneficiariesRefund;
